export const Travelmode = [
    { name: 'BY AIR', code: 'BY AIR' },
    { name: 'BY CAR (SELF BOOKING)', code: 'BY CAR' },
    { name: 'BY TRAIN (SELF BOOKING)', code: 'BY TRAIN' },
]